import { z } from 'zod';

export const formSchema = z.object({
  ma_nx: z.string().nonempty('Mã nhập xuất là bắt buộc'),
  ten_nx: z.string().nonempty('Tên nhập xuất là bắt buộc'),
  ten_nx2: z.string().optional(),
  status: z.coerce.number().optional()
});

export type FormValues = z.infer<typeof formSchema>;

export const initialValues: FormValues = {
  ma_nx: '',
  ten_nx: '',
  ten_nx2: '',
  status: 1
};
